import classnames from 'classnames'
import {
  connect,
  ContentTag,
  CurrentPage,
  Obj,
  provideLayoutComponent,
} from 'scrivito'

import { PushDrawer } from '@/Atomic/Templates/PushDrawer'
import { useSidebarContext } from '@/Components/Sidebar/SidebarContext'
import './defaultPageLayoutComponent.scss'

type ObjClass = Parameters<typeof provideLayoutComponent>[0]

export function provideDefaultPageLayoutComponent(objClass: ObjClass) {
  provideLayoutComponent(objClass, ({ page }) => {
    const showLeftSidebar = !!page.get('layoutShowLeftSidebar')
    const showRightSidebar = !!page.get('layoutShowRightSidebar')
    const showSidebar = showLeftSidebar || showRightSidebar

    return (
      <>
        {!!page.get('layoutShowHeader') && (
          <ContentTag tag="header" content={page} attribute="layoutHeader" />
        )}

        <BackgroundWrapper
          backgroundColor={page.get('layoutMainBackgroundColor')}
        >
          {showSidebar ? <SidebarLayout page={page} /> : <CurrentPage />}
        </BackgroundWrapper>

        {!!page.get('layoutShowFooter') && (
          <ContentTag tag="footer" content={page} attribute="layoutFooter" />
        )}
      </>
    )
  })
}

const BackgroundWrapper = connect(function BackgroundWrapper({
  backgroundColor,
  children,
}: {
  children: React.ReactNode
  backgroundColor?: unknown
}) {
  if (typeof backgroundColor !== 'string') return children
  if (backgroundColor === 'transparent') return children

  return <section className={`bg-${backgroundColor}`}>{children}</section>
})

const SidebarLayout = connect(function SidebarLayout({ page }: { page: Obj }) {
  const { isOpen, closeSidebar } = useSidebarContext()
  return (
    <>
      <div
        className={classnames('dxp-main-wrapper', {
          'dxp-sidebar-left-show': isOpen,
        })}
      >
        <div className="dxp-sidebar-left">
          <ContentTag content={page} attribute="layoutLeftSidebar" />
        </div>
        <div
          className="dxp-sidebar-backdrop"
          onClick={closeSidebar}
          aria-hidden="true"
        />
        <main>
          <div className="container-fluid">
            <CurrentPage />
          </div>
        </main>
        <PushDrawer />
      </div>
      <div id="offcanvas" />
    </>
  )
})
